export const initEnvironmentReact = {
  SENTRY_DSN: '${VITE_SENTRY_DSN}',
  SENTRY_RELEASE: '${SERVICE_VERSION}',
  SERVICE_VERSION: '${SERVICE_VERSION}',
  FINGERPRINT_TOKEN: '${FINGERPRINT_TOKEN}',
  CDN_URL: '${VITE_CDN_URL}',
}
